export interface SynopsisLocationState {
  from?: string;
  fromLabel?: string;
}

/**
 * Back link and breadcrumb for Account Synopsis. The trail matches the entry point
 * (Exec Ops > Accounts, My Accounts, …). Opened without one (e.g. from the account name on
 * the Account Plan page), account-team users (AE, CSM…) go to My Accounts: they have no
 * Exec Ops, and its trail would point them at a page they can't open.
 */
export const synopsisTrail = (
  state: SynopsisLocationState,
  accountTeam: boolean,
  withOrg: (path: string) => string
) => {
  const backPath =
    state.from ??
    withOrg(accountTeam ? "/my-portfolio-accounts" : "/ops?tab=accounts");
  const backLabel =
    state.fromLabel ?? (accountTeam ? "My Accounts" : "Accounts");
  const fromOpsAccounts =
    backLabel === "Accounts" ||
    backPath.includes("/ops") ||
    (!state.from && !accountTeam);
  const breadcrumbTrail: { title: string; to?: string }[] = [
    ...(fromOpsAccounts ? [{ title: "Exec Ops", to: withOrg("/ops") }] : []),
    { title: backLabel, to: backPath },
    { title: "Account Synopsis" },
  ];
  return { backPath, backLabel, breadcrumbTrail };
};
